import React from 'react';
import StatsPanel from '../../Statistics/StatsPanel';

const StatistiquesTab = ({ client }) => {
    return (
        <div>
            <StatsPanel compact={true} clientId={client?.id} />
        </div>
    );
}

export default StatistiquesTab;